export default [
  {
    title: `Sobre a Up.p`,
    text: `Com o empréstimo FGTS da Up.p, você tem as menores taxas e contratação totalmente digital.`,
  },
  {
    title: `O que é o empréstimo de antecipação do FGTS?`,
    text: `É uma modalidade que permite antecipar o valor do seu Saque Aniversário em até 12 parcelas. A contratação é simples e rápida, permitindo inclusive para negativados, e basta ter o saldo disponível a partir de R$ 49,00 para contratar.`,
  },
  {
    title: `Quais são as etapas de contratação?`,
    text: `
    Após selecionar a sua oferta em nossa plataforma, você será direcionado para a contratação na plataforma da Up.p:
    <ul>
      <li>Autorize a modalidade de Saque Aniversário no seu aplicativo do FGTS;</li>
      <li>Permita a consulta do seu saldo pela Up.p;</li>
      <li>Escolha a melhor opção de valor e parcelas para você;</li>
      <li>Envie seu documento de identidade para comprovação das informações;</li>
      <li>Faça a assinatura da selfie de forma 100% digital;</li>
      <li>Aguarde a análise;</li>
      <li>Após a aprovação do empréstimo, receba o valor na sua conta no mesmo dia ou, no máximo, em 1 dia útil.</li>
    </ul>
    `,
  },
  {
    title: `Qual a documentação necessária para contratar?`,
    text: `
      As documentações necessárias são:
      <ul>
        <li>Documento de identidade: RG ou CNH.</li>
        <li>Assinatura com selfie.</li>
      </ul>
    `,
  },
  {
    title: `Quais são os requisitos para pedir o empréstimo?`,
    text: `
      Os requisitos para solicitar o empréstimo são:
      <ul>
        <li>É necessário possuir FGTS.</li>
        <li>É necessário ter saldo a partir de R$ 49,00.</li>
      </ul>
    `,
  },
]
